module.exports = __webpack_public_path__ + "media/loginbg.7f37cf4a.mp4";